var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.125,
    height: 72.125,
    viewBox: "0 0 72.125 72.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_BTN",
    "data-name": "Close BTN",
    transform: "translate(-147.879 2.121)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(183.942 0) rotate(45)",
    fill: "none",
    stroke: "#cedef4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(77.875 -120.125) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M183.919,43.941a1.364,1.364,0,0,0,.949-.392,1.341,1.341,0,0,0,.393-.948V35.27H192.6a1.364,1.364,0,0,0,.949-.392,1.341,1.341,0,0,0,.393-.948,1.321,1.321,0,0,0-1.33-1.329h-7.339V25.27a1.33,1.33,0,0,0-2.661,0V32.6h-7.339a1.329,1.329,0,1,0,0,2.658h7.339V42.59a1.3,1.3,0,0,0,1.309,1.351Z",
    fill: "#cedef4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M183.919,43.941a1.364,1.364,0,0,0,.949-.392,1.341,1.341,0,0,0,.393-.948V35.27H192.6a1.364,1.364,0,0,0,.949-.392,1.341,1.341,0,0,0,.393-.948,1.321,1.321,0,0,0-1.33-1.329h-7.339V25.27a1.33,1.33,0,0,0-2.661,0V32.6h-7.339a1.329,1.329,0,1,0,0,2.658h7.339V42.59a1.3,1.3,0,0,0,1.309,1.351Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#cedef4",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.95e8957bb6efbfc1f39024987834d5ed.svg";
export { ForwardRef as ReactComponent };